import {GetDefaultIndex} from '../../components';
import { useGetShareholderGroupsCommonInfoQuery } from "../../features/board/boardSlice";
import {useShareholderGroupRoutes} from './routes';

export {useShareholderGroupRoutes};

export default GetDefaultIndex({title: 'گروه های سهامداران', query: useGetShareholderGroupsCommonInfoQuery});
